<template>
  <div class="clearfix ui_select"
    :class="{ disabled: !!disabled, error: modelError }"
    :style="{ width: computedWidth }"
    @scroll.stop>
    <div class="item--wrap">
      <p class="selected-item"
         @click.stop="toggleList">
        <span v-if="!activeItem && placeholder">
          {{ placeholder }}
        </span>
        <span class="ellipsis"
          :class="activeItem ? activeItem.cssClass : null">{{ getItemText(activeItem) }}</span>
        <i class="icon icon--drop-down"></i>
      </p>
      <transition name="slide">
        <ul class="item__list" :style="{ width: computedWidth, maxHeight: computedMaxHeight }"
            :class="{'is-show': showList}"
            v-show="showList">
          <li class="item__list-item"
              v-for="(item, index) in selectItems" :key="index"
              :class="{ on: item.value === value, 'raw-text': useRawText }"
              :title="getItemText(item)"
              @click="onChange(item.value)">
          <span class="item-name"
                :class="[item.cssClass, {'exit': getItemText(item) === 'exit'}]"
                :title="getItemText(item)">{{ getItemText(item) }}</span>
          </li>
        </ul>
      </transition>
    </div>
    <strong v-if="modelError" class="validation-text">{{ $t(`common.validationErrorText.${modelError}`) }}</strong>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import { isPlainObject } from '@/libs/utils'

export default {
  name: 'UiSelectbox',
  props: [
    'value',
    'items',
    'width',
    'maxHeight',
    'title',
    'disabled',
    'modelError',
    // no text-transform
    'useRawText',
    'placeholder'
  ],
  data () {
    return {
      showList: false,
      renderedWidth: 0
    }
  },
  computed: {
    computedWidth () {
      if (!this.width && this.renderedWidth) {
        return this.renderedWidth + 'px'
      } else if (typeof this.width === 'number') {
        return this.width + 'px'
      }
      return this.width
    },
    computedMaxHeight () {
      if (typeof this.maxHeight === 'number') {
        return this.maxHeight + 'px'
      }
      return this.maxHeight
    },
    selectItems () {
      return this.items.map(item => {
        if (!isPlainObject(item)) {
          return {
            value: item
          }
        }
        return item
      })
    },
    activeItem () {
      return this.selectItems.find(item => item.value === this.value)
    }
  },
  watch: {
    showList (value) {
      let listener = () => {
        this.showList = false
      }

      let dimmed = document.getElementsByClassName('dimmed')
      if (value) {
        document.body.addEventListener('click', listener, false)
        Array.from(dimmed).forEach(v => {
          v.addEventListener('click', listener, false)
        })
        this.$nextTick().then(() => {
          const activeEl = this.$el.querySelector('.item__list-item.on')

          if (activeEl) {
            activeEl.parentNode.scrollTop = activeEl.offsetTop
          }
        })
      } else {
        document.body.removeEventListener('click', listener)
        Array.from(dimmed).forEach(v => {
          v.removeEventListener('click', listener, false)
        })
      }
    }
  },
  mounted () {
    this.renderedWidth = this.$el.offsetWidth
    EventBus.$on('closeAllUiSelectBox', () => {
      this.showList = false
    })
  },
  methods: {
    toggleList () {
      if (this.disabled) {
        return
      }
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeUserMenu')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      EventBus.$emit('closeReportPageList')
      this.showList = !this.showList
    },
    onChange (value) {
      this.showList = false
      this.$emit('input', value)
      this.$emit('changed')
    },
    getItemText (item) {
      if (!item) {
        return ''
      }
      return String(item.i18n || (item.text || item.value))
    }
  }
}
</script>

<style lang="scss">
.ui_select {
  cursor: pointer;
  text-align: left;
  display: inline-block;
  position: relative;

  &.disabled {
    pointer-events: none;
    .item--wrap{
      background-color:#e6e6e6;
      border: 1px solid #d7d7d7;

      span {
        color: #999999;
      }

      .selected-item {
        .icon {
          opacity: 0.3;
        }
      }
    }
  }

  &.error {
    .validation-text {
      color: $errorColor;
    }
  }

  .item--wrap {
    position: relative;
    padding-left: 15px;
    display: inline-block;
    width: 100%;
    height: 38px;
    line-height: 36px;
    border-radius: 6px;
    border: solid 1px #bbbbbb;
    background-color: #ffffff;
    box-sizing: border-box;
    font-size: 14px;
    color: #2f2f2f;

    .selected-item {
      color: #2f2f2f;
      position: relative;
      height: 100%;

      &>span {
        display: block;
        margin-right: 35px;
      }
      .icon {
        pointer-events: none;
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
      }
    }

    .item__list {
      width: 100%;
      overflow-y: auto;
      position: absolute;
      top: -1px;
      left: -1px;
      background-color: #fff;
      z-index: 10000001;
      border-radius: 6px;
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08);
      max-height: 320px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      opacity: 0;
      transform-origin: top;
      transition: transform .2s ease, opacity .1s ease;

      &.top {
        top: auto;
        bottom: -1px;
        transform-origin: bottom;
      }

      &.is-show {
        opacity: 1;
      }

      .item__list-item {
        padding-left: 15px;
        height: 38px;
        color: #444;
        cursor: pointer;
        /*text-transform: capitalize;*/

        &.raw-text {
          text-transform: none;
        }

        &.on {
          background-color: #f4f4f4;
        }

        &:hover {
          background-color: #ebebeb;
        }

        .item-name {
          display: block;
          margin-right: 10px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;

          &.exit {
            text-transform: capitalize;
          }
        }
      }
    }
  }

  .validation-text {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    padding-left: 5px;
    font-weight: bold;
  }
}
.slide-enter, .slide-leave-to{
  transform: scaleY(0);
  opacity: 0;
}
</style>
